import { TrackingData } from "./SearchForm";

export type DataContainerAppilier = (json: TrackingData) => void;

export type BCT = {
  trackOnNextPageImpression: () => void;
  sendEventToTrackingServer: () => void;
};

export type OTracking = {
  bct: BCT;
};

let bct: BCT;
export let isInitialized: boolean;

/**
 *
 * @param dataContainer encompassing tracking data
 * @param fn applied with dataContainer
 * @param type the type for debug messages
 */
export function submitToTracking(dataContainer: TrackingData, fn: DataContainerAppilier, type: string) {
  try {
    fn(dataContainer);
    window.o_global.debug.warn(type + " submitting " + JSON.stringify(dataContainer));
  } catch (e) {
    window.o_global.debug.warn(e + "");
  }
}

/**
 *
 * @param trackingData
 */
export function sendTrackingDataForNextPI(trackingData: TrackingData) {
  if (bct && typeof bct.trackOnNextPageImpression === "function") {
    submitToTracking(trackingData, bct.trackOnNextPageImpression, "Track on next PI");
  }
}

/**
 *
 * @param dataContainer
 */
export function sendEventToTracking(dataContainer: TrackingData) {
  if (bct && typeof bct.sendEventToTrackingServer === "function") {
    submitToTracking(dataContainer, bct.sendEventToTrackingServer, "Track event");
  }
}

export function readTrackingFromStorage() {
  let trackingKey: string | null;
  const storage = new window.o_global.Storage(() => window.sessionStorage);

  if (storage.isAvailable) {
    trackingKey = storage.getItem("squirrel_searchTracking");
    if (Boolean(trackingKey).valueOf()) {
      storage.removeItem("squirrel_searchTracking");
      sendEventToTracking(JSON.parse(trackingKey as string));
    }
  }
}

export function init(otracking: OTracking) {
  // store API reference
  bct = otracking.bct;

  readTrackingFromStorage();

  isInitialized = true;
}

export interface Tracking {
  isInitialized: boolean | undefined;
  init: typeof init;
  sendEventToTracking: typeof sendEventToTracking;
  sendTrackingDataForNextPI: typeof sendTrackingDataForNextPI;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const tracking = { isInitialized, init, sendEventToTracking, sendTrackingDataForNextPI };

window.o_global &&
  window.o_global.eventLoader.onReady(1, () => {
    // Deduplication
    if (window.squirrelTrackingInitialized) {
      return;
    }
    window.squirrelTrackingInitialized = true;

    if (bct) {
      init(window.o_tracking);
    } else {
      window.o_global.eventLoader.onLoad(1, function () {
        init(window.o_tracking);
      });
    }
  });
